import { SUB_CATEGORY_FIND_MANY } from '../lib/endpoints/category';
import axios from '../lib/axios';
import { SubCategoryModel } from '../models/subCategoryCopy';

export const getSubCategoriesByMerchantId = async ({
  merchantId,
}: {
  merchantId: string;
}): Promise<SubCategoryModel[]> => {
  const resData = await axios.post(SUB_CATEGORY_FIND_MANY, { filter: { merchant_id: merchantId } });
  return resData?.data?.data;
};
